export default "__VITE_ASSET__ChyqAwpP__"